import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppUpdateDialogComponent } from './app-update-dialog.component';

@NgModule({
  declarations: [AppUpdateDialogComponent],
  exports: [AppUpdateDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
})
export class AppUpdateDialogModule {}
